module.exports = __webpack_public_path__ + "static/media/maca_cortada.0a2fa141.png";